import { useMemo } from 'react';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import { toUpperCase } from 'utils/toLowerCase';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';

interface UseReturnItemOperatableParams {
  platform: General.PlatformUpperCase;
  region: General.Region;
  internalStoreId: string;
}
export function useReturnItemOperatable(params: UseReturnItemOperatableParams) {
  const { platform, region, internalStoreId } = params;
  const operatable = useGetPermission()('操作弃单', {
    platform,
    region: toUpperCase(region),
    storeId: Number(internalStoreId),
  });

  return { operatable };
}

interface UseReturnItemContactEnableParams {
  platform: General.PlatformUpperCase;
  returnStatus: string;
  operatable: boolean;
}
export function useReturnItemContactEnable(params: UseReturnItemContactEnableParams) {
  const { platform, returnStatus, operatable } = params;
  const contactEnable = useMemo(
    () => operatable && !(platform === 'MERCADO' && returnStatus === 'closed'),
    [operatable, platform, returnStatus],
  );
  return { contactEnable };
}

/** 退货单条目的操作权限与展示开关（单一职责：权限与平台展示规则） */
export function useReturnItemPermissions(params: {
  platform: General.PlatformUpperCase;
  region: General.Region;
  internalStoreId: string;
  returnStatus: string;
}) {
  const { platform, region, internalStoreId, returnStatus } = params;

  const { operatable } = useReturnItemOperatable({ platform, region, internalStoreId });

  const { contactEnable } = useReturnItemContactEnable({ platform, returnStatus, operatable });

  const { showStoreType, showSellerType } = useMemo(
    () => ({
      showStoreType: platform === 'SHOPEE' || isTiKTokUpperCase(platform),
      showSellerType: platform === 'SHOPEE',
    }),
    [platform],
  );

  return {
    operatable,
    contactEnable,
    showStoreType,
    showSellerType,
  };
}
